import React from 'react';
import { useIonRouter } from '@ionic/react';
import { IonButton } from '@ionic/react';
import badgesWreath from '../../assets/badges-wreath.svg';
import trendUpArrow from '../../assets/trend-up-arrow.svg';
import trendDownArrow from '../../assets/trend-down-arrow.svg';

import { BadgeTrend } from '../../types/teamUserSummary';

interface BadgesWidgetProps {
  count: number;
  trend?: BadgeTrend;
}

const BADGES_ICON_URL = 'https://storage.googleapis.com/rev-public/icons/Badges%20Earned.svg';

export const BadgesWidget: React.FC<BadgesWidgetProps> = ({ count, trend }) => {
  const router = useIonRouter();

  // Split count into two lines for large numbers
  const countStr = count.toString();
  const midpoint = Math.ceil(countStr.length / 2);
  const firstLine = countStr.slice(0, midpoint);
  const secondLine = countStr.slice(midpoint);

  return (
    <div className="bg-white flex min-w-60 flex-col overflow-hidden items-stretch justify-center flex-1 shrink basis-[0%] my-auto px-5 py-4 rounded-[10px]">
      <div className="flex items-center">
        <div className="flex items-center gap-3">
          <img
            src={BADGES_ICON_URL}
            alt="Badges"
            className="w-8 h-8"
          />
          <div className="text-[#2D2D2D] text-base font-medium">
            Badges Earned
          </div>
        </div>
      </div>

      <div className="flex flex-1 flex-col justify-end mt-3">
        <div className="flex items-start justify-between gap-4">
          {/* Left column: Number and Text */}
          <div className="flex flex-col flex-1">
            <div className="flex items-center justify-between gap-4">
              <div className="flex items-baseline gap-3">
                <div className="text-[#928881] text-5xl font-bold leading-tight">
                  {firstLine}
                  {secondLine && <><br />{secondLine}</>}
                </div>
                {/* Trend indicator to the right of count */}
                {/* {trend && trend.value !== 0 && trend.isPositive !== 'same' && (
                  <div className="flex items-center gap-1">
                    <img
                      src={trend.isPositive === 'positive' ? trendUpArrow : trendDownArrow}
                      alt=""
                      className="w-4 h-4"
                    />
                    <div className={`text-xs font-medium ${
                      trend.isPositive === 'positive' ? 'text-[#54C082]' : 'text-red-500'
                    }`}>
                      {trend.isPositive === 'positive' ? '+' : ''}{trend.value}
                    </div>
                  </div>
                )} */}
              </div>
              {/* Button aligned with number */}
              <IonButton
                size="small"
                color="primary"
                fill="solid"
                onClick={() => router.push('/all-courses', 'none')}
              >
                Browse Courses
              </IonButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
